export default "__VITE_ASSET__CdVfUS44__"